import * as React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';

import Callout from '../../site/Callout';
import { bind, inject } from '../../../utils/decorators';
import { ApiStore } from '../../../stores/ApiStore';
import { VorgangStore } from '../../../stores/VorgangStore';
import { Panel, Button, Form, FormGroup, Col } from 'react-bootstrap';
import { IAuftrag } from '../../../models/ApiTypes';

import Select, { Option } from 'react-select';
import 'react-select/dist/react-select.css';

interface ISesUebernahmeMesswerteProps {
  auftragId: string;
  vorgangId: string;
  onTriggerDocumentRefresh?: () => void;
}

/** Komponente zur Übernahme von Messwerten SES aus einem alten Auftrag */
@observer
export default class SesUebernahmeMesswerte extends React.Component<ISesUebernahmeMesswerteProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable auftraege?: Array<IAuftrag>;
  @observable quellAuftrag?: string | number | true;

  @action setAuftraege(auftraege: Array<IAuftrag>) {
    this.auftraege = auftraege;
 }

  @action clearAuftraege() {
    this.auftraege = undefined;
  }

  @bind @action handleQuellAuftragChanged(option: Option) {
    this.quellAuftrag = option.value ? option.value : '';
  }

  @bind async handleUebernehmeMesswerte() {
    const { vorgangId } = this.props;
    if (this.quellAuftrag) {
      const response = await this.apiStore.ubernehmeMesswerteSes(this.props.vorgangId, this.quellAuftrag.toString());
      if (response.ok) {
        this.vorgangStore.loadVorgang(vorgangId);
      }
    }
  }

  async componentDidMount() {
    this.clearAuftraege();
    // TODO: Kategorie anhand Kategorie aktueller Auftrag
    let response = await this.apiStore.auftraegemesswerte('ses');
    if (response.ok) {
      this.setAuftraege(response.json);
    }
  }

  render() {
    let auftraegeArray: Array<Option>;
    auftraegeArray = [];
    if (this.auftraege) {
      for (let auftrag of this.auftraege) {
        let option = { value: auftrag.refnr, label: `${auftrag.auftrag_name} (${auftrag.refnr})`, key: auftrag.refnr };
        auftraegeArray.push(option);
      }
    }

    return (
      <div className="auswertung-messwerte">
        {this.props.vorgangId && (
           (true)
            ?
            <div>

            <Form horizontal={true}>
              <Panel
                header="Quelle"
                footer={(
                  <div className="text-right">
                    <Button disabled={!this.quellAuftrag} bsStyle="success" onClick={() => this.handleUebernehmeMesswerte()}>Daten übernehmen</Button>
                  </div>
                )}
              >
                <Callout bsStyle="success">
                  Wählen Sie hier den Auftrag aus dem die Messwerte übernommen werden sollen. Nach der Bestätigung werden die Daten in den aktuellen Auftrag kopiert (inkl. Dokumente).<br/><br/>
                  Im Anschluß können die Vorgänge abgeschlossen werden, für die Messwerte erforderlich sind (z.B. Kalibrierung, Stückprüfung).
                </Callout>

                <FormGroup controlId="Übernehmen aus">
                  <Col sm={1}/>
                  <Col sm={10}>
                    <Select
                      name="auftrag-quelle"
                      clearable={false}
                      value={this.quellAuftrag}
                      onChange={this.handleQuellAuftragChanged}
                      options={auftraegeArray}
                      placeholder="Auftrag auswählen..."
                      noResultsText="Keine Aufträge entsprechen der Suche..."
                    />
                  </Col>
                  <Col sm={1}/>
                </FormGroup>

              </Panel>
            </Form>

            </div>
            :
            <Callout bsStyle="danger">
              Das Erzeugen der Auswertung ist erst möglich wenn für beide Aufstellflächen alle benötigten Messwerte eingegeben wurden.
            </Callout>
        )}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/ses/SesUebernahmeMesswerte.tsx